
    // IMPORTS
    import { defineComponent, computed, PropType, provide, ref, Ref } from 'vue'
    import { Button } from '@progress/kendo-vue-buttons'
    import { focusFirstInvalidField } from '@/util'

    export default defineComponent({
        name: 'inputForm',

        components: {
            'k-button': Button
        },

        props: {
            submitText: { type: String as PropType<string>, required: true },
            submitAction: { type: Function as PropType<Function>, required: true },
        },

        setup(props) {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const currentValidationStatus: Ref<{ [id: string]: boolean }> = ref({})

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const isValidationActive = ref(false)

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const anyValidationError = computed(
                () => Object.values(currentValidationStatus.value).find(v => v === false) === false
            )

            const computedData = { anyValidationError }

            /********************************************************************************************************************
             PUBLIC METHODS AND EVENT HANDLERS
             ********************************************************************************************************************/
            function onSubmit() {
                isValidationActive.value = false
                isValidationActive.value = true

                if (anyValidationError.value) {
                    focusFirstInvalidField(
                        Object.keys(currentValidationStatus.value),
                        (id) => currentValidationStatus.value[id] === false
                    )
                } else {
                    props.submitAction()
                }
            }

            const publicMethods = { onSubmit }

            /********************************************************************************************************************
             PROVIDE
             ********************************************************************************************************************/
            provide('isValidationActive', isValidationActive)

            provide('setValidationResult', (id: string, isValid: boolean) => {
                currentValidationStatus.value[id] = isValid
            })

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...computedData, ...publicMethods }
        }
    });
